import React, { useState } from 'react';
import Select from 'react-select';
import DatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker';
import moment from "moment";
import Icon from '../../UI/Icon/Icon';

import { enGB } from "date-fns/locale"; // Import the Dutch locale

import "./PeriodSelector.sass";

registerLocale("enGB", enGB);

const customSelectStyles = {
  control: (base) => ({
    ...base,
    height: '46px',
    'min-height': '46px',
    cursor: 'pointer',
  }),
  placeholder: (base) => ({
    ...base,
    color: '#ABABAB',
  }),
};

export const PeriodSelector2 = ({
  searchPeriod,
  setSearchPeriod,
  eventData,
  setEventData,
  period,
}) => {
  const [startCalendrDate, setStartCalendarDate] = useState(new Date(eventData.periodStart));
  const [endCalendarDate, setEndCalendarDate] = useState(
    new Date(moment(eventData.periodEnd).utc().startOf('day').toISOString())
  );

  const changeSearchPeriodHandler = (item) => {
    setSearchPeriod(item);

    const { minDate, maxDate } = eventData;

    switch (item.value) {
      case 0: {
        changeStartDate(new Date(minDate));
        changeEndDate(new Date(maxDate));
        break;
      }

      case 1: {
        changeStartDate(new Date(moment(maxDate)));
        changeEndDate(new Date(maxDate));
        break;
      }

      case 2: {
        const toWeek = moment(maxDate).set('day', 1)
        changeStartDate(new Date(toWeek));
        changeEndDate(new Date(maxDate));
        break;
      }

      case 3: {
        const toMonth = moment(maxDate).set('date', 1);

        changeStartDate(new Date(toMonth));
        changeEndDate(new Date(maxDate));
        break;
      }

      default:
        break;
    }
  };

  const changeStartDate = (date) => {
    if (moment(date).format() === "Invalid date") return;

    setStartCalendarDate(date);

    const calculatedStartDate =
      moment(date)
      .utc()
      .add("h", eventData.timeZone)
      .startOf('day')
      .toISOString();

    setEventData(prev => ({ ...prev, periodStart: calculatedStartDate }));
  };

  const changeEndDate = (date) => {
    if (moment(date).format() === "Invalid date") return;
    setEndCalendarDate(date);

    const calculatedEndDate =
      moment(date)
      .utc()
      .add("h", eventData.timeZone)
      .endOf('day')
      .toISOString();

    setEventData(prev => ({ ...prev, periodEnd: calculatedEndDate }));
  };

  const changeCustomPeriod = (option) => {
    const value = option === "prev" ? -1 : 1;
    let dateKey = "";
    const { periodStart, periodEnd } = eventData;
    let end = '';

    switch (searchPeriod.value) {
      case 1:
        dateKey = "d";
        end = moment(periodEnd).utc().add(value, dateKey).startOf('day').toISOString();
        break;
      case 2:
        dateKey = "week";
        end = moment(periodStart).utc().add(value, dateKey).startOf('day').endOf("week").toISOString();
        break;
      case 3:
        dateKey = "month";
        end = moment(periodStart).utc().add(value, dateKey).endOf("month").startOf('day').toISOString();
        break;
      
      default: break;
    };

    changeStartDate(new Date(moment(periodStart).add(value, dateKey)));
    changeEndDate(new Date(end));
  };

  return (
    <article className='period-selector'>
      <div className="add-event__block period-selector__select">
        <label>Period</label>
        <Select
          options={period}
          placeholder='Select period'
          name='searchProfilePeriod'
          classNamePrefix='custom-select'
          value={searchPeriod}
          onChange={changeSearchPeriodHandler}
          className='custom-select'
          styles={customSelectStyles}
          theme={(theme) => ({
            ...theme,
            colors: {
              ...theme.colors,
              primary: '#6071B5',
              primary25: '#F2F4FE',
              primary50: '#F2F4FE',
              primary75: '#F2F4FE',
            },
          })}
        />
      </div>
      <fieldset className="period-selector__custom-period">
        <legend>Select dates</legend>

        <button
          className="btn-primary period-selector__prev-button"
          disabled={
            searchPeriod.value === 0 ||
            searchPeriod.value === 4 ||
            eventData.periodStart <= eventData.minDate
          }
          onClick={() => changeCustomPeriod("prev")}
        >
          <Icon name={"chevron"} />
        </button>

        <div className="add-event__block period-selector__date-picker">
          <label>Start date</label>

          <DatePicker
            selected={startCalendrDate}
            onChange={(date) => changeStartDate(date)}
            selectsStart
            startDate={startCalendrDate}
            endDate={endCalendarDate}
            minDate={new Date(eventData.minDate)}
            maxDate={endCalendarDate}
            dateFormat="dd.MM.yyyy"
            disabled={searchPeriod.value !== 4}
            locale="enGB"
          />
        </div>
    
        <div className="add-event__block period-selector__date-picker">
          <label>End date</label>

          <DatePicker
            selected={endCalendarDate}
            onChange={changeEndDate}
            selectsEnd
            startDate={startCalendrDate}
            endDate={endCalendarDate}
            minDate={startCalendrDate}
            maxDate={new Date(eventData.maxDate)}
            dateFormat="dd.MM.yyyy"
            disabled={searchPeriod.value !== 4}
            locale="enGB"
          />
        </div>

        <button
          className="btn-primary period-selector__next-button"
          disabled={
            searchPeriod.value === 0 || 
            searchPeriod.value === 4 ||
            eventData.periodEnd >= moment(eventData.maxDate).startOf("d").toISOString()
          }
          onClick={() => changeCustomPeriod("next")}
        >
          <Icon name={"chevron"} />
        </button>
      </fieldset>
    </article>
  )
}

export const PeriodSelector = React.memo(PeriodSelector2)
